import React, { Component } from 'react';
import styled from 'styled-components';
import { FaCheck, FaTimes } from 'react-icons/fa';

import Modal from '../../containers/common/Modal';
import { FlyInTransition } from '../../components/transitions/transitions';
import StyledTappable from '../../components/common/StyledTappable';
import profile from '../../images/profile.svg';
import cross from '../../images/cross.svg';
// const AddContainer = styled.div`
//   width: 18px;
//   height: 18px;
//   display: flex;
//   flex-shrink: 0;
//   border-radius: 9px;
//   background-color: #e4e4e4;
//   justify-content: center;
//   align-items: center;
// `;

// const AddedContainer = styled.div`
//   width: 18px;
//   height: 18px;
//   border-radius: 9px;
//   display: flex;
//   flex-shrink: 0;
//   justify-content: center;
//   align-items: center;
//   background: #ffbb00;
// `;

// const AddText = styled.div`
//   color: #ffbb00;
//   height: 10px;
//   width: 10px;
// `;

// const AddedIcon = styled(FaCheck)`
//   color: #ffffff;
//   height: 10px;
//   width: 10px;
// `;

// const CloseContainer = styled(StyledTappable)`
//   width: 1.625rem;
//   height: 1.625rem;
//   border-radius: 8px;
//   border: 1px solid #eee;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;
// const HeaderText = styled.span`
//   font-style: normal;
//   font-weight: 600;
//   font-size: 14px;
//   line-height: 140%;
//   letter-spacing: 0.25px;
//   color: #0f0b28;
// `;
// const RelativeName = styled.span`
//   font-family:  ;
//   font-style: normal;
//   font-weight: 600;
//   font-size: 12px;
//   line-height: 150%;
//   letter-spacing: 0.25px;
//   color: #0f0b28;
// `;
// const CloseIcon = styled(FaTimes)`
//   color: #413958;
// `;
// const RelativeGender = styled.span`
//   font-family:  ;
//   font-style: normal;
//   font-weight: 400;
//   font-size: 12px;
//   line-height: 150%;
//   letter-spacing: 0.5px;
//   color: #585969;
// `;
// export class RelativeSelect extends Component {
//   constructor(props) {
//     console.log('props of relative select', props);
//     super(props);
//     this.state = {
//       showModal: true,
//     };
//   }

//   hideModal = () => {
//     this.setState({ showModal: false });
//     setTimeout(this.props.hideModal, 200);
//   };
//   handleOutsideClick = (e) => {
//     // ignore clicks on the component itself
//     if (this.node && this.node.contains(e.target)) {
//       return;
//     }
//     this.hideModal();
//   };
//   render() {
//     const { relatives } = this.props;
//     const renderRelatives = (ele) => {
//       return (
//         <div
//           className="patient-container cursor-pointer"
//           key={ele.relativeId}
//           style={{ backgroundColor: '#eff3f6' }}
//           onClick={() => {
//             this.props.selectRelative(ele);
//             this.hideModal();
//           }}
//         >
//           {this.props.selectedRelative &&
//           ele.id === this.props.selectedRelative.id ? (
//             <AddedContainer></AddedContainer>
//           ) : (
//             <AddContainer></AddContainer>
//           )}
//           <div className="txt-black-600-12 pl-12 flex-col">
//             <RelativeName>{ele.name}</RelativeName>
//             <RelativeGender>
//               {ele.gender}, {ele.phone}
//             </RelativeGender>
//           </div>
//         </div>
//       );
//     };
//     return (
//       <Modal>
//         <div className="modalContainer" onClick={this.handleOutsideClick}>
//           <FlyInTransition
//             in={this.state.showModal}
//             mountOnEnter
//             unmountOnExit
//             onExited={this.hideModal}
//             appear
//           >
//             <div className="modalBody" ref={(node) => (this.node = node)}>
//               <div className="modalHeader">
//                 <div className="flex items-center mx-1">
//                   <img src={profile} style={{ marginRight: '8px' }} />
//                   <HeaderText>Choose Patient</HeaderText>
//                 </div>
//                 <button onClick={this.hideModal} type="button">
//                   <svg
//                     width="12"
//                     height="12"
//                     viewBox="0 0 12 12"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M10.5859 12L12 10.5859L7.41407 5.99998L12 1.41405L10.5859 -6.18103e-08L6.00002 4.58593L1.41405 -4.62726e-07L-6.18103e-08 1.41405L4.58593 5.99998L-4.62725e-07 10.5859L1.41405 12L6.00002 7.41407L10.5859 12Z"
//                       fill="#585969"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               <div className="modalDetails">
//                 {relatives.map(renderRelatives)}
//               </div>
//             </div>
//           </FlyInTransition>
//         </div>
//       </Modal>
//     );
//   }
// }

// export default RelativeSelect;

const AddContainer = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  flex-shrink: 0;
  border-radius: 9px;
  background-color: #e4e4e4;
  justify-content: center;
  align-items: center;
`;

const AddedContainer = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  background: #ffbb00;
`;

const AddText = styled.div`
  color: #ffbb00;
  height: 10px;
  width: 10px;
`;

const AddedIcon = styled(FaCheck)`
  color: #ffffff;
  height: 10px;
  width: 10px;
`;

const CloseContainer = styled(StyledTappable)`
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 8px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const HeaderText = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;
const RelativeName = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;
const CloseIcon = styled(FaTimes)`
  color: #413958;
`;
const RelativeGender = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: #585969;
`;
export class RelativeSelect extends Component {
  constructor(props) {
    console.log('props of relative select', props);
    super(props);
    this.state = {
      showModal: true,
      patientData: props.selectedRelative ? props.selectedRelative : 'all',
    };
  }

  hideModal = () => {
    this.setState({ showModal: false });
    setTimeout(this.props.hideModal, 200);
  };
  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.hideModal();
  };
  optionSelect(type) {
    //this.setState({ isChecked: !this.state.isChecked });
    //this.setState({ patientData: type });
    this.props.selectRelative(type);
    this.hideModal();
  }

  render() {
    const { relatives } = this.props;
    const renderRelatives = (ele) => {
      return (
        <div
          className="patient-container cursor-pointer"
          key={ele.relativeId}
          style={{ backgroundColor: '#eff3f6' }}
          onClick={() => {
            this.props.selectRelative(ele);
            this.hideModal();
          }}
        >
          {this.props.selectedRelative &&
          ele.id === this.props.selectedRelative.id ? (
            <AddedContainer></AddedContainer>
          ) : (
            <AddContainer></AddContainer>
          )}
          <div className="txt-black-600-12 pl-12 flex-col">
            <RelativeName>{ele.name}</RelativeName>
            <RelativeGender>
              {ele.gender}, {ele.phone}
            </RelativeGender>
          </div>
        </div>
      );
    };

    return (
      <Modal>
        <div className="modalContainer" onClick={this.handleOutsideClick}>
          <FlyInTransition
            in={this.state.showModal}
            mountOnEnter
            unmountOnExit
            onExited={this.hideModal}
            appear
          >
            <div className="modalBody" ref={(node) => (this.node = node)}>
              <div className="modalHeader">
                <div className="flex items-center mx-1">
                  {/* <img src={profile} style={{ marginRight: '8px' }} /> */}
                  <HeaderText>Filter Claims</HeaderText>
                </div>
                <button onClick={this.hideModal} type="button">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5859 12L12 10.5859L7.41407 5.99998L12 1.41405L10.5859 -6.18103e-08L6.00002 4.58593L1.41405 -4.62726e-07L-6.18103e-08 1.41405L4.58593 5.99998L-4.62725e-07 10.5859L1.41405 12L6.00002 7.41407L10.5859 12Z"
                      fill="#585969"
                    />
                  </svg>
                </button>
              </div>
              {/* <div className="modalDetails" style={{ background: 'red' }}>
                {relatives.map(renderRelatives)}
              </div> */}
              <div style={{ display: 'flex', height: '200px' }}>
                <ModalBodyLeft>
                  <ModalLeftOptions>Patient</ModalLeftOptions>
                  {/* <ModalLeftOptions>Service Type</ModalLeftOptions>
                  <ModalLeftOptions>Dependants</ModalLeftOptions> */}
                  {/* <ModalLeftOptions>Claim Status</ModalLeftOptions> */}
                </ModalBodyLeft>
                <ModalBodyRight>
                  <ModalRightOptions>
                    <StyledCheckbox
                      type="checkbox"
                      checked={this.state.patientData === 'all'}
                      onChange={() => this.setState({ patientData: 'all' })}
                    ></StyledCheckbox>
                    <ModalRightText
                      color={this.state.patientData === 'all'}
                      weight={this.state.patientData === 'all'}
                    >
                      All
                    </ModalRightText>
                  </ModalRightOptions>
                  <ModalRightOptions>
                    <StyledCheckbox
                      type="checkbox"
                      checked={this.state.patientData === 'self'}
                      onChange={() => this.setState({ patientData: 'self' })}
                    ></StyledCheckbox>
                    <ModalRightText
                      color={this.state.patientData === 'self'}
                      weight={this.state.patientData === 'self'}
                    >
                      Self
                    </ModalRightText>
                  </ModalRightOptions>
                  {console.log('relative sare', this.state.relatives)}
                  {relatives &&
                    relatives.map((item) => {
                      return (
                        <ModalRightOptions key={item.id}>
                          <StyledCheckbox
                            type="checkbox"
                            checked={this.state.patientData === item.id}
                            onChange={() =>
                              this.setState({ patientData: item.id })
                            }
                          ></StyledCheckbox>
                          <ModalRightText
                            color={this.state.patientData === item.id}
                            weight={this.state.patientData === item.id}
                          >
                            {item.name}
                          </ModalRightText>
                        </ModalRightOptions>
                      );
                    })}
                  {/* <ModalRightOptions>
                    <StyledCheckbox
                      type="checkbox"
                      checked={true}
                      onChange={() =>
                        this.setState({ isChecked: !this.state.isChecked })
                      }
                    ></StyledCheckbox>
                    <ModalRightText>
                      OPD Policy (16242-12444-98328)
                    </ModalRightText>
                  </ModalRightOptions>
                  <ModalRightOptions>
                    <StyledCheckbox
                      type="checkbox"
                      checked={true}
                      onChange={() =>
                        this.setState({ isChecked: !this.state.isChecked })
                      }
                    ></StyledCheckbox>
                    <ModalRightText>
                      OPD Policy (16242-12444-98328)
                    </ModalRightText>
                  </ModalRightOptions> */}
                </ModalBodyRight>
              </div>
              <div>
                <ModalFooter>
                  <FooterLeft onClick={() => this.optionSelect('')}>
                    Clear Filters
                  </FooterLeft>
                  <FooterRight
                    onClick={() => this.optionSelect(this.state.patientData)}
                  >
                    Apply Filters
                  </FooterRight>
                </ModalFooter>
              </div>
            </div>
          </FlyInTransition>
        </div>
      </Modal>
    );
  }
}

export default RelativeSelect;

const ModalBodyLeft = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #e6e6e6;
`;
const ModalLeftOptions = styled.button`
  color: #000;

  font-size: 16px;
  font-weight: 700;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  padding-left: 0.7rem;
  padding-right: 0.5rem;
`;
const ModalBodyRight = styled.div`
  overflow-y: auto;
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const ModalRightOptions = styled.div`
  width: 100%;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-bottom: 0.5rem;
  display: flex;
  border-bottom: 1px solid #e6e6e6;
`;
const ModalRightText = styled.span`
  color: ${(props) => `${props.color ? '#000' : '#767787'}`};
  font-weight: ${(props) => `${props.weight ? '700' : '500'}`};
  width: 150px;
  //display: flex;
  padding-left: 0.5rem;
  //color: #767787;

  font-size: 14px;
  //font-weight: 500;
`;

const StyledCheckbox = styled.input`
  width: 1.5rem;
  height: 1.2rem;
  border: 1px solid #a5a6bb;
  border-radius: 6px;
  align-self: flex-start;
  &:checked {
    accent-color: #ffbb00;
  }
`;

const ModalFooter = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f0f3f6;
`;
const FooterLeft = styled.button`
  color: #000;

  font-size: 16px;
  font-weight: 500;
`;

const FooterRight = styled.button`
  display: flex;
  padding: 12px 24px;
  align-items: flex-start;
  gap: 10px;
  color: white;
  border-radius: 8px;
  background: #ffbb00;
  color: #fff;

  font-size: 16px;
  font-weight: 700;
`;
